export const lineItemGuidSelector = (state) => state.product.lineItemGuid;
